// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  Button,
  Input,
} from '../../../../components';
import styles from './styles';


const BookshopCustomerForm = (props) => {
  const {
    classes,
    bookshopCustomer,
    requestStatus,
    changeCustomerFields,
    issueVoucher,
  } = props;

  const onChange = (value, name) => {
    changeCustomerFields(value, name);
  };

  return (
    <form className={classes.container}>
      <Input
        fixedWidth
        label={'Full Name:'}
        type={'text'}
        name={'fullName'}
        inputType={'text'}
        value={bookshopCustomer.fullName}
        onChange={onChange}
      />
      <Input
        fixedWidth
        label={'Email:'}
        type={'text'}
        name={'email'}
        inputType={'text'}
        value={bookshopCustomer.email}
        onChange={onChange}
      />
      <Input
        fixedWidth
        label={'Mobile (optional):'}
        type={'text'}
        name={'mobile'}
        inputType={'text'}
        value={bookshopCustomer.mobile}
        onChange={onChange}
      />
      {
        !requestStatus.status ? (
          <p className={classes.errorText}>{`${requestStatus.messages[0]}`}</p>
        ) : null
      }
      <Button
        text={'ISSUE VOUCHER'}
        onPress={issueVoucher}
      />
    </form>
  );

};

BookshopCustomerForm.propTypes = {
  classes: PropTypes.object,
  bookshopCustomer: PropTypes.object,
  requestStatus: PropTypes.object,

  changeCustomerFields: PropTypes.func,
  issueVoucher: PropTypes.func,
};

BookshopCustomerForm.defaultProps = {
  classes: {},
  bookshopCustomer: {},
  requestStatus: {},

  changeCustomerFields: () => { },
  issueVoucher: () => { },
};

export default withStyles(styles)(BookshopCustomerForm);
